import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import TrendResearchDoughnutChart from '@features/trend-research/components/common/TrendResearchDoughnutChart';
import useQueryString from '@features/trend-research/hooks/useQueryString';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { findFabricSummary } from '@services/trendResearch';

const Charts = () => {
	const dispatch = useDispatch();
	const [dataFromDatabase, setDataFromDatabase] = useState({});
	const queryString = useQueryString();
	const getData = async () => {
		try {
			if (!queryString || queryString.trim() === '') {
				return;
			}

			const searchParams = new URLSearchParams(queryString);
			if (searchParams.has('fiberList')) {
				searchParams.delete('fiberList');
			}

			const updatedQueryString = `?${searchParams.toString()}`;

			const data = await findFabricSummary(updatedQueryString);
			setDataFromDatabase(data);
		} catch {
			/* Empty Block */
		}
	};

	useEffect(() => {
		if (!queryString || queryString.trim() === '') {
			return;
		}
		(async () => {
			dispatch(openLoader());
			getData();
			dispatch(closeLoader());
		})();
	}, [queryString]);

	return (
		<div className="chart-and-graph-section">
			<div className="chart-graph-grid fabric-chart-graph-grid pb-3">
				<TrendResearchDoughnutChart
					title={'Top Composition'}
					dataSet={dataFromDatabase.compositionWisePercentageMap}
				/>

				<TrendResearchDoughnutChart
					title="Top Individual Fiber"
					dataSet={dataFromDatabase.fiberWisePercentage}
				/>
			</div>
		</div>
	);
};

export default Charts;
